import React from 'react';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import LeadershipTeamAlignment from './children/LeadershipTeamAlignment';
import StakeholderGroupsAlignment from './children/StakeholderGroupsAlignment';

const AlignmentInsights = (props) => {
    return (
        <>
            <AsyncSection api={props.fetchBenchmarkAlignmentScoreApi}>
                <LeadershipTeamAlignment />
            </AsyncSection>

            <AsyncSection api={props.fetchRankDeltaApi}>
                <StakeholderGroupsAlignment />
            </AsyncSection>
        </>
    );
};

export default AlignmentInsights;